import { useMemo } from 'react';
import { useTeamMemberDetailsForSelect } from './useTeamMemberDetailsForSelect';

/**
 * {@link useTeamMemberDetailsForSelect}, with `memberDetails` additionally
 * mapped into `{value, label, employeeId, rate}` options ready for a member
 * picker `Dropdown`.
 *
 * @param {string | null | undefined} teamId
 * @returns {object} Same as useTeamMemberDetailsForSelect, plus membersOptions
 */
export function useMembersOptionsForSelect(teamId) {
  const teamMemberDetailsForSelect = useTeamMemberDetailsForSelect(teamId);
  const { memberDetails } = teamMemberDetailsForSelect;

  const membersOptions = useMemo(() => {
    if (!memberDetails || typeof memberDetails !== 'object') return [];
    return Object.entries(memberDetails)
      .filter(([, m]) => !m?.deleted)
      .map(([uid, m]) => ({
        value: uid,
        label: m.employeeId
          ? `${m.userName || uid} (${m.employeeId})`
          : m.userName || uid,
        employeeId: m.employeeId,
        rate: m.rates ?? 0,
      }))
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }, [memberDetails]);

  return {
    ...teamMemberDetailsForSelect,
    membersOptions,
  };
}
